// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class MOMENTUM extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.ProjectName = 'Momentum';
        this.Comments = 'Momentum';
        // #endregion
        this.SetIndicatorLine('MOMENTUM', Color.Red, 1, LineStyle.SimpleChart);
        this.SetLevelLine('Zero', 0, Color.Gray, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.MomPeriod = 20;
        super.InputParameter(new InputParameterInteger('MomPeriod', 'Period of momentum:', 0, 1, 99999, 0, 1));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'MOMENTUM(' + this.MomPeriod + ')';
    }
    getCustomName() {
        return 'MOMENTUM (' + this.ProjectName + ')';
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.MomPeriod) {
            return;
        }
        this.SetValue(0, 0, this.CurrentData.getPriceByType(PriceType.Close, 0) -
            this.CurrentData.getPriceByType(PriceType.Close, this.MomPeriod));
    }
}
